export const iconFontAwesomeDevicesHardwareMemory = (
	<i className="fa-solid fa-memory"></i>
);
